import React from 'react';
import { useTranslation } from 'react-i18next';

function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mt-auto border-t border-line bg-beige-100">
      <div className="mx-auto max-w-6xl px-6 py-8 md:px-10">
        <div className="text-xs tracking-wide text-ink-400">
          © {currentYear} · {t('footer.rights')}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
